import { Box } from '@zillow/constellation-10';

import { ParagraphStyledComponent } from '../ParagraphStyledComponent';
import { TextStyledComponent } from '../TextStyledComponent';

import type { TextStyledComponentProps } from '../../model/TextStyledComponent';
import type { ParagraphStyledComponentProps } from '../../model/ParagraphStyledComponent';

type ContentStyledComponent = {
  title: TextStyledComponentProps;
  content: Array<ParagraphStyledComponentProps>;
  csEventsHandler?: ({ text }: { text: string }) => void;
  csEventsIdMap?: Record<string, string>;
};

export const ContentStyledComponent = ({ title, content, csEventsHandler, csEventsIdMap }: ContentStyledComponent) => {
  return (
    <>
      {title.text && (
        <Box css={{ marginBottom: '400' }}>
          <TextStyledComponent styledComponentContent={title} />
        </Box>
      )}
      {content.map((paragraph, i) => {
        return (
          <Box key={i} css={{ marginBlock: '200' }} data-testid="ParagraphStyledComponentSpacer">
            <ParagraphStyledComponent
              heading={paragraph.heading}
              body={paragraph.body}
              type={paragraph.type}
              csEventsHandler={csEventsHandler}
              csEventsIdMap={csEventsIdMap}
            />
          </Box>
        );
      })}
    </>
  );
};
